/** SPA kökü: /unyedoviz (PHP) veya Vite base (/web/dist) */
export function getAppBasename(): string {
  const path = window.location.pathname

  if (path === '/unyedoviz' || path.startsWith('/unyedoviz/')) return '/unyedoviz'

  const viteBase = String(import.meta.env.BASE_URL || '/').replace(/\/$/, '')
  if (viteBase && viteBase !== '/' && (path === viteBase || path.startsWith(`${viteBase}/`))) {
    return viteBase
  }

  return '/'
}

/** Canlı pano — kiox URL’si korunur */
export function getBoardUrl(): string {
  const base = getAppBasename()
  if (base === '/unyedoviz') return '/unyedoviz/kiox/'
  if (base === '/' || base === '/web/dist') return '/kiox/'
  return `${base}/kiox/`
}
